<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>
<ng-template #bodyTemplate>
  <prox-activation-checklist *ngIf="isValidateActivated"
    [activationErrors]="activationService.activateErrors"
    [entityName]="account!.name"
    [activationService]="activationService"></prox-activation-checklist>
  <div class="qb-list-actions">
    <p-button [disabled]="isReadOnly()" (click)="onAdd()" label="Add Account Administrator"
      icon="pi pi-plus" size="small"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
    <div class="ml-auto flex items-center">
      <p-checkbox [(ngModel)]="showInactive" [binary]="true" (onChange)="onShowInactiveChanged()"
        name="showInactive" inputId="showInactive"></p-checkbox>
      <label for="showInactive" class="ml-2">Show Inactive Account Administrators</label>
    </div>
  </div>
  <div class="qb-layout-grid">
    <prox-ag-grid  gridId="accountAdminsGrid" [gridOptions]="gridOptions" [rowData]="visibleAdministrators"></prox-ag-grid>
  </div>
</ng-template>